import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Loan, EmiDue, Repayment, GiftCardDetails } from '../loans';
import { environment } from '../../../environments/environment';
import { UtilService } from '../loans-card/utils.service';
import { LoanService } from '../loans.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'zest-loans-detail',
  templateUrl: './loans-detail.component.html',
  styleUrls: ['./loans-detail.component.scss']
})

export class LoansDetailComponent implements OnInit {

  @Input() selectedLoan: Loan;
  @Input() viewType: string;
  @Input() emiDateStatus: any;
  @Output() openQuickPayModal = new EventEmitter<boolean>();
  @Output() hideLoanDetails = new EventEmitter<boolean>();
  @Output() triggerSMSfromDetails = new EventEmitter();
  public logoBaseUrl: string;
  public status: string;
  public repayments: any;
  public lateFees: number;
  public nextEmiDue = new EmiDue();
  public otherEmiDues: any[];
  public numberOfEmiDues = 1;
  public nextDueAmount: number;
  public loanDetails: boolean;
  public giftVoucher: GiftCardDetails[];
  public showEMIAmount: number;
  public activateVoucher: boolean;
  public schedulerRepayments: Repayment[];
  public fetchingData = true;
  public deviceInfo: string;
  public isMobile = false;
  public showLoanDetailComponents: boolean;
  public toggleScheduleTable = false;

  constructor(
    public utilService: UtilService,
    private LoanService: LoanService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    if (this.deviceService.getDeviceInfo()) {
      this.deviceInfo = this.deviceService.getDeviceInfo().device;
    }
    if ((window.innerWidth < 641) || (this.deviceInfo === 'android' || this.deviceInfo === 'iphone' || this.deviceInfo === 'ipod' || this.deviceInfo === 'blackberry' || this.deviceInfo === 'windows-phone' || this.deviceInfo === 'vita')) {
      this.isMobile = true;
    }
    if (this.isMobile) {
      this.showLoanDetailComponents = false;
    } else {
      this.showLoanDetailComponents = true;
    }
    this.logoBaseUrl = environment.s3BucketUrl;
    this.repayments = this.selectedLoan.Repayments;
    this.fetchingData = true;
    this.lateFees = this.utilService.getLateFees(this.selectedLoan.Repayments);
    this.nextEmiDue = this.utilService.getNextEmiDue(this.selectedLoan.Repayments);
    this.otherEmiDues = this.utilService.getOtherEmiDues(this.selectedLoan.Repayments);
    this.findUpcomingEMI();
    this.LoanService.getLoan(this.selectedLoan.LoanExternalId || this.selectedLoan.ExternalId).subscribe(result => {
      this.selectedLoan = { ...this.selectedLoan, ...result };
      this.LoanService.getLoanApplicationDetails(this.selectedLoan.LoanExternalId || this.selectedLoan.ExternalId).subscribe(application => {
        this.selectedLoan.application = application;
        if ((this.viewType === 'Active') && (this.selectedLoan.Status !== 'Approved') && (this.schedulerRepayments) && (this.schedulerRepayments.length > 0)) {
          const nextLoan = this.schedulerRepayments.find(loan => {
            return (loan.State !== 'Paid');
          });
          this.nextDueAmount = nextLoan ? nextLoan.PrincipalDue + nextLoan.InterestDue : 0;
          const emiDueLoans = this.schedulerRepayments.filter(loan => ((loan.State === 'Late') || (loan.State === 'Upcoming')));
          this.numberOfEmiDues = emiDueLoans.length;
          this.showEMIAmount = this.utilService.getAmountToPay(this.nextEmiDue, this.otherEmiDues);
        }
        this.selectedLoan = this.selectedLoan;
        this.loanDetails = true;
        if (this.selectedLoan.MerchantDetails) {
          if (this.selectedLoan.Status === 'Active') {
            this.activateVoucher = false;
          } else {
            this.activateVoucher = true;
          }
        } else {
          this.activateVoucher = false;
        }
        this.fetchingData = false;
      }, error => {
        this.fetchingData = false;
      });
    }, error => {
      this.fetchingData = false;
    });
  }

  findUpcomingEMI() {
    if ((this.selectedLoan.Repayments) && (this.selectedLoan.Repayments.length > 0)) {
      this.schedulerRepayments = [...this.selectedLoan.Repayments];
      let upcomingEMI = false;
      this.selectedLoan.Repayments.forEach((emi, i) => {
        const emiDueDate = new Date(emi.DueDate);
        const currentDate = new Date();
        const daysDiff = Math.ceil((emiDueDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24));
        if (emi.State === 'Pending') {
          if (daysDiff < 0) {
            this.schedulerRepayments[i].State = 'Late';
          } else if (daysDiff >= 0 && !upcomingEMI) {
            this.schedulerRepayments[i].State = 'Upcoming';
            upcomingEMI = true;
          } else {
            this.schedulerRepayments[i].State = 'To Be paid';
          }
        }
      });
    }
  }

  showLoans() {
    this.hideLoanDetails.emit(false);
  }

  onResize() {
    this.deviceInfo = this.deviceService.getDeviceInfo().device;
    if ((window.innerWidth < 641) || (this.deviceInfo === 'android' || this.deviceInfo === 'iphone' || this.deviceInfo === 'ipod' || this.deviceInfo === 'blackberry' || this.deviceInfo === 'windows-phone' || this.deviceInfo === 'vita')) {
      this.isMobile = true;
      this.showLoanDetailComponents = false;
    } else {
      this.isMobile = false;
      this.showLoanDetailComponents = true;
    }
  }

  getMonth(nextDueDate) {
    const d = new Date(nextDueDate);
    const month = d.toLocaleString('en-us', { month: 'long' });
    return month;
  }
  showLoanComponents() {
    this.showLoanDetailComponents = !this.showLoanDetailComponents;
  }
  showHideToggle() {
    this.toggleScheduleTable = !this.toggleScheduleTable;
  }
  triggerSMSLink() {
    this.triggerSMSfromDetails.emit();
  }
}
